'use client'

import { COOKIES } from '@/constants/environment-variables'
import Cookies from 'js-cookie'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'


export default function LoadingPage() {
  const router = useRouter()
  const token = Cookies.get(COOKIES.ACCESS_TOKEN)

  useEffect(() => {
    token ? router.push('/home') : router.push('/login')
  }, [])

  return (
    <></>
  )

}
